/**
 * The bar on top of the poster editor (design handoff "barre d'options") : Taille, Finition,
 * Aperçu 3D — fixed labels, the values chosen show in the screens they open. Raises "size",
 * "finish" and "preview3d".
 */
fx.ns("desktop.poster", class PosterOptionsBar extends fx.Component {

    onReady()
    {
        super.onReady();

        this.on("click", this._onClick, this.node);
    }

    _onClick(e)
    {
        let button = e.target && e.target.closest ? e.target.closest("[data-open]") : null;
        if (button)
            this.trigger(button.dataset.open);
    }

    render()
    {
        let item = (open, label, icon) =>
            '<button type="button" class="poOption" data-open="' + open + '">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true">' + icon + '</svg>' + label +
            '</button>';

        return '<nav class="poOptions" aria-label="' + fx.text("Options du poster") + '">' +
                    item("size", fx.text("Taille"), '<rect x="6" y="3" width="12" height="18" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M2.5 6v12M21.5 6v12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>') +
                    item("finish", fx.text("Finition"), '<rect x="4" y="2.5" width="16" height="19" rx="1" fill="none" stroke="currentColor" stroke-width="1.8"/><rect x="7.5" y="6" width="9" height="12" fill="none" stroke="currentColor" stroke-width="1.4"/>') +
                    item("preview3d", fx.text("Aperçu 3D"), '<path d="M12 2.5l8 4.5v10l-8 4.5-8-4.5V7z M4 7l8 4.5L20 7 M12 11.5v10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>') +
                '</nav>';
    }
});
